import AddBusinessIcon from "@mui/icons-material/AddBusiness";
import ListBankTransfers from "./List";
import { BANK_TRANSFERS, PaymentServicePath } from "utils/constants";
import permissions from "app/permissions";

export const resources = {
  isMenu: true,
  icon: <AddBusinessIcon />,
  name: PaymentServicePath + BANK_TRANSFERS,
  title: "Банкови трансфери",
  list: <ListBankTransfers />,
  permission: permissions.canPreviewBankTransfers,
};
